"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdditionalActionName = void 0;
var AdditionalActionName;
(function (AdditionalActionName) {
    AdditionalActionName["openCashier"] = "OpenCashier";
    AdditionalActionName["openIdentityVerification"] = "OpenIdentityVerification";
})(AdditionalActionName || (exports.AdditionalActionName = AdditionalActionName = {}));
//# sourceMappingURL=registration.interfaces.js.map